import { useTranslation } from "react-i18next";
import React from "react";
import Authen from "src/assets/img/Authentication.gif";
import { Result } from "src/assets/imports/antdComponents";

const AuthScreen = ({ profile }: { profile: boolean }) => {
	const { t } = useTranslation();
	const message = "You do not have any profiles assigned. Please contact your administrator for support.";
	return (
		<div className="flex flex-col justify-center items-center h-screen w-screen bg-[#F2F6FA]">
			<div className="text-center">
				{profile ? (
					<>
						<div className="inline-block">
							<div className="relative">
								<img src={String(Authen)} alt="Authen" />
							</div>
						</div>
						<p className="text-[1.33333333rem] text-[--neutral-grey-darker]">{t("Authenticating...")}</p>
					</>
				) : (
					<Result status="403" className="bg-[#F2F6FA]" title="" subTitle={t(message)} />
				)}
			</div>
		</div>
	);
};

export default AuthScreen;
